import { render, staticRenderFns } from "./NetworkSelector.vue?vue&type=template&id=48ad0577&scoped=true"
import script from "./NetworkSelector.vue?vue&type=script&lang=js"
export * from "./NetworkSelector.vue?vue&type=script&lang=js"
import style0 from "./NetworkSelector.vue?vue&type=style&index=0&id=48ad0577&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad0577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ad0577')) {
      api.createRecord('48ad0577', component.options)
    } else {
      api.reload('48ad0577', component.options)
    }
    module.hot.accept("./NetworkSelector.vue?vue&type=template&id=48ad0577&scoped=true", function () {
      api.rerender('48ad0577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/shared/NetworkSelector.vue"
export default component.exports